export default "dist/images/block-image-box-basic.cbb7240.png";